import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import * as React from 'react';
import { deepmerge } from '@mui/utils';
import { CssVarsProvider as JoyCssVarsProvider, useColorScheme as useJoyColorScheme, extendTheme, THEME_ID as JOY_THEME_ID } from '@mui/joy/styles';
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';
import { ThemeOptionsContext, highDensity } from 'docs/src/modules/components/ThemeContext';
import BrandingCssVarsProvider from './BrandingCssVarsProvider';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var defaultTheme = createTheme({
  colorSchemes: {
    light: true,
    dark: true
  },
  cssVariables: {
    colorSchemeSelector: 'data-mui-color-scheme'
  }
});
function JoyModeObserver() {
  var themeOptions = React.useContext(ThemeOptionsContext);
  var _useJoyColorScheme = useJoyColorScheme(),
    setMode = _useJoyColorScheme.setMode;
  React.useEffect(function () {
    if (themeOptions.paletteMode) {
      setMode(themeOptions.paletteMode);
    }
  }, [themeOptions.paletteMode, setMode]);
  return null;
}
export function DemoPageThemeProvider(_ref) {
  var children = _ref.children,
    hasJoy = _ref.hasJoy;
  var themeOptions = React.useContext(ThemeOptionsContext);
  var joyTheme = React.useMemo(function () {
    return hasJoy ? extendTheme() : undefined;
  }, [hasJoy]);
  return /*#__PURE__*/_jsxs(BrandingCssVarsProvider, _extends({}, themeOptions, {
    children: [/*#__PURE__*/_jsx(ThemeProvider, {
      theme: defaultTheme
    }), hasJoy ? /*#__PURE__*/_jsxs(JoyCssVarsProvider, {
      theme: _defineProperty({}, JOY_THEME_ID, joyTheme),
      children: [/*#__PURE__*/_jsx(JoyModeObserver, {}), children]
    }) : children]
  }));
}
export function DemoInstanceThemeProvider(_ref3) {
  var _upperTheme$palette;
  var children = _ref3.children,
    runtimeTheme = _ref3.runtimeTheme;
  var _React$useContext = React.useContext(ThemeOptionsContext),
    dense = _React$useContext.dense,
    direction = _React$useContext.direction;
  var upperTheme = useTheme();
  var upperMode = upperTheme == null || (_upperTheme$palette = upperTheme.palette) == null ? void 0 : _upperTheme$palette.mode;
  var _theme = React.useMemo(function () {
    var resultTheme = createTheme({
      cssVariables: {
        colorSchemeSelector: 'data-mui-color-scheme'
      },
      colorSchemes: {
        light: true,
        dark: true
      },
      direction: direction
    }, dense ? highDensity : {});
    if (upperMode) {
      Object.assign(resultTheme, resultTheme.colorSchemes[upperMode]);
    }
    if (runtimeTheme && Object.prototype.toString.call(runtimeTheme) === '[object Object]') {
      try {
        return deepmerge(resultTheme, runtimeTheme);
      } catch (_unused) {
        return resultTheme;
      }
    }
    return resultTheme;
  }, [runtimeTheme, dense, direction, upperMode]);
  return /*#__PURE__*/ /* - use a function to ensure that the upper theme (branding theme) is not spread to the demo theme */ /* - a function will skip the CSS vars generation logic */_jsx(ThemeProvider, {
    theme: function theme() {
      return upperTheme && JOY_THEME_ID in upperTheme ? _extends({}, _theme, _defineProperty({}, JOY_THEME_ID, upperTheme == null ? void 0 : upperTheme[JOY_THEME_ID])) : _theme;
    },
    children: children
  });
}